const initBlock = async function( block ) {
	const $slider = block.find( ".js-scroller-slider" );

	$slider.each( async function() {
		const { Swiper } = await import( "swiper" );
		const { Autoplay } = await import( "swiper/modules" );
		await import( "swiper/css" );

		new Swiper( $slider[0], {
			modules: [Autoplay],
			slidesPerView: "auto",
			spaceBetween: 15,
			loop: true,
			freeMode: true,
			speed: 5000,
			freeModeMomentum: false,
			simulateTouch: false,
			allowTouchMove: false,
			autoplay: {
				delay: 1,
				pauseOnMouseEnter: true,
			},
			breakpoints: {
				767: {
					slidesPerView: 3,
				},
				1279: {
					slidesPerView: 4,
				}
			},
		} );
	} );
};

themeUtils.loadBlock( initBlock, "logo-scroller", ".section-logo-scroller" );
